// extracted by mini-css-extract-plugin
module.exports = {"vanlife-roadtrips-P":"P_vanlife-roadtrips-P__Cwt7G"};